import { gql } from '@apollo/client'

const GET_FEATURE_GATING_LIMIT = gql`
  query featureGatingLimit($planName: String!) {
    featureGatingLimit(planName: $planName) {
      featureName
      visible
      lowestPlanTier
      limit
    }
  }
`

export default GET_FEATURE_GATING_LIMIT
